import React, { useState } from 'react';

const VolumeControl = ({ videoRef, interactiveMode, volume, setVolume }) => {

    const [isVolumeBarVisible_, setVolumeBarVisible_] = useState(false);
    const [volume_, setVolume_] = useState(100);

    const handleVolumeChange = (event) => {
        const volumeLevel = event.target.value;
        videoRef.current.volume = volumeLevel;
        setVolume_(volumeLevel);

        setVolume(+volumeLevel);
    };

    return (
        <div
            className={`flex items-center h-14 text-gray-50 duration-300 transition-transform transform-origin-left ${isVolumeBarVisible_ && 'translate-x-1'}`}
            onMouseEnter={() => setVolumeBarVisible_(true)}
            onMouseLeave={() => setVolumeBarVisible_(false)}
        >
            {isVolumeBarVisible_ ?
                <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    value={volume_}
                    className="w-full"
                    onChange={handleVolumeChange}
                />
                :
                volume_ == 0?
                <i className="fa-solid fa-volume-xmark volume-icon"></i>
                :
                <i className="fa-solid fa-volume-high volume-icon"></i>

            }
        </div>
    );
};

export default VolumeControl;